"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var metricValue_1 = require("../features/metricValue");
var window_1 = require("../features/window");
var models_1 = require("../models");
var EffectiveDefinition_1 = require("../models/EffectiveDefinition");
var Result_1 = require("../models/Result");
var DefaultTransformRegistry_1 = require("./DefaultTransformRegistry");
exports.materializeTable = function (definition, sourceTable, registry) {
    if (registry === void 0) { registry = DefaultTransformRegistry_1.DefaultTransformRegistry; }
    var _a;
    try {
        var transforms = generateTransforms(definition, registry);
        return Result_1.Ok(applyTransforms(transforms, sourceTable));
    }
    catch (e) {
        return Result_1.Err(new Result_1.MetricsEngineError(((_a = e) === null || _a === void 0 ? void 0 : _a.message) || 'Failed to materialize table'));
    }
};
var generateTransforms = function (definition, registry) {
    var windowTransforms = generateWindowTransforms(definition);
    var columnTranforms = generateColumnTransforms(definition, registry);
    var tableTransforms = Object.entries(definition.tableTransforms).map(function (_a) {
        var key = _a[0], transform = _a[1];
        var creator = registry[transform.type];
        if (creator === undefined) {
            throw new Error("Couldn't find transform creator in registry: " + transform.type + ", " + Object.keys(registry));
        }
        return creator(definition, key);
    });
    return windowTransforms.concat(columnTranforms).concat(tableTransforms);
};
var generateColumnTransforms = function (definition, registry) {
    return Object.entries(definition.schema)
        .filter(function (_a) {
        var key = _a[0], columnSchema = _a[1];
        return columnSchema.calculation !== undefined && !EffectiveDefinition_1.isTableCalcRef(columnSchema.calculation);
    })
        .map(function (_a) {
        var key = _a[0], columnSchema = _a[1];
        var calcType = columnSchema.calculation.type;
        var creator = registry[calcType];
        if (creator === undefined) {
            throw new Error("Couldn't find transform creator in registry: " + calcType + ", " + Object.keys(registry));
        }
        return creator(definition, key);
    });
};
var generateWindowTransforms = function (definition) {
    var window = window_1.getWindowFeature(definition);
    var accessor = metricValue_1.buildTimestampAccessor(definition);
    return [function (sourceTable, previousStep) { return window_1.applyWindow(previousStep, window, models_1.throwIfUndefined(accessor)); }];
};
var applyTransforms = function (transforms, sourceTable) {
    return transforms.reduce(function (previousStep, transform) { return transform(sourceTable, previousStep); }, sourceTable);
};
//# sourceMappingURL=materializeTable.js.map